import { colors } from '@/constants';
import styled from 'styled-components';

export const Row = styled.div<{ $bottom?: number }>`
  gap: 4px;
  display: flex;
  width: 100%;
  padding: 8px 16px;
  flex-direction: row;
  max-width: var(--mobile);
  position: absolute;
  top: 0;
  transform: translateY(-100%);
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  z-index: 9999999;
  align-items: center;
  justify-content: space-between;
  transition: all 0.3s ease-in-out;
  background-color: ${colors.alert.green110};
`;

export const Card = styled.div`
  padding: 4px 8px;
  border-radius: 4px;
  background-color: ${colors.alert.green100};
`;

export const CardText = styled.p`
  border-radius: 4px;
  font-size: 10px;
  font-weight: 600;
  color: ${colors.alert.green110};
`;

export const Content = styled.div`
  padding: 2px 0px;
  flex: 1;
  min-width: 0;
`;

export const Text = styled.p`
  font-size: 14px;
  font-weight: 500;
  overflow: hidden;
  text-align: left;
  width: 100%;
  min-width: 0;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: ${colors.alert.green100};
`;

export const Button = styled.div`
  padding-left: 4px;
  cursor: pointer;
  border: none;
  background-color: transparent;
`;
